import type { TOC } from '@ember/component/template-only';

const Wizard2RouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default Wizard2RouteTemplate;
